<template>
  <el-popover 
    trigger="hover" 
    placement="right"
    popper-class="discount-panel-info-popover"     
  >
    <img 
      src="@/assets/orderTest/order-page/order-test-panel/discount_red_tag.svg"
      alt="red tag"
      class="absolute right-4 -top-3"
    >
    <div class="absolute right-5 top-4 w-20">
      <p class="new-price">{{ currency.symbol + price }}</p>
      <p v-if="originalPrice" class="original-price mt-2">
        {{ currency.symbol + originalPrice.toFixed(2) }}
      </p>
    </div>
    <p class="panel-name mt-4">{{ panelName }}</p>
    <div class="panel-details mt-3.5">
      <p>{{ $t("OrderPage[\"Order Id: { panelId }\"]", { panelId: panelId }) }} </p>
      <p class="mt-2.5" v-if="originalPrice">
        {{ $t("OrderPage[\"Original Price: { currency.symbol + originalPrice.toFixed(2) }\"]", { originalPrice: currency.symbol + originalPrice.toFixed(2) }) }} 
      </p>
      <p v-if="panelTestNameList.length > 0" class="mt-2.5">
        {{ $t("OrderPage[\"Tests: { panelTestNameList.join(', ') }\"]", { panelTestNameList: panelTestNameList.join(', ') }) }} 
      </p>
    </div>
    <template v-slot:reference>
      <span class="material-icons-outlined info-icon">info</span>
    </template>
  </el-popover>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  props: {
    panelId: {
      type: Number,
      default: null
    },
    panelName: {
      type: String,
      default: ""
    },
    price: {
      type: Number,
      default: 0
    },
    originalPrice: {
      type: Number,
      default: null
    },
    panelTestNameList: {
      type: Array,
      default: () => []
    }

  },


  computed: {
    ...mapState(["currency"]),
    ...mapGetters("orderTest/tests", ["testList"]),
  },
}
</script>

<style scoped>
.new-price {
  font-weight: 500;
  font-size: 21px;
  line-height: 14px;
  color: #FFFFFF;
  text-align: center;
}


.original-price {
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  text-decoration-line: line-through;
  color: #D8D8D8;
  text-align: center;
}

.panel-name {
  width: 243px;
  font-weight: 500;
  font-size: 13px;
  line-height: 14px;
  color: #FFFFFF;
  word-break: normal;
}

.panel-details {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #979797;
}

.info-icon {
  font-size: 20px;
}
</style>